import { useState } from 'react';
import { getSessionStorage, setSessionStorage } from '@/shared/lib/storage';

/**
 * トークン使用率オーバーライドの状態を管理するフック
 * セッションストレージに状態を保存
 */
export const useTokenUsageOverride = () => {
  const [overridePercentage, setOverridePercentage] = useState<number | null>(() =>
    getSessionStorage('debug-token-usage-percentage'),
  );

  const updateOverridePercentage = (value: number | null) => {
    setOverridePercentage(value);
    setSessionStorage('debug-token-usage-percentage', value);
  };

  return {
    overridePercentage,
    updateOverridePercentage,
  };
};
